import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'

// TODO rename
const facetDefaults = new Map<FacetName, string[]>()
facetDefaults.set(FacetName.price, [, , '48', '1000', '10000'] as string[])

interface FacetConfig {
    filters: FilterName[]
    isRange: boolean
    defaults: string[]
}

const facetFilterMap = new Map<FacetName, FacetConfig>()
const filterFacetMap = new Map<FilterName, { facet: FacetName }>()

const add = (facet: FacetName, ...filters: FilterName[]) => {
    facetFilterMap.set(facet, {
        filters,
        isRange: filters[0].startsWith('min_'),
        defaults: facetDefaults.get(facet) || [],
    })
    filters.forEach((filter) => filterFacetMap.set(filter, { facet }))
}

add(FacetName.acceleration_values, FilterName.acceleration_values)
add(FacetName.acceleration_values, FilterName.acceleration_values)
add(FacetName.aggregated_trim, FilterName.aggregated_trim)
add(FacetName.aggregated_trim, FilterName.aggregated_trim)
add(FacetName.annual_tax_values, FilterName.annual_tax_values)
add(FacetName.annual_tax_values, FilterName.annual_tax_values)
add(FacetName.axle_config, FilterName.axle_config)
add(FacetName.battery_charge_time_values, FilterName.battery_charge_time_values)
add(FacetName.battery_quick_charge_time_values, FilterName.battery_quick_charge_time_values)
add(FacetName.battery_range_values, FilterName.battery_range_values)
add(FacetName.bedroom_layout, FilterName.bedroom_layout)
add(FacetName.berth, FilterName.berth)
add(FacetName.body_type, FilterName.body_type)
add(FacetName.boot_size_values, FilterName.boot_size_values)
add(FacetName.cab_type, FilterName.cab_type)
add(FacetName.category_tag, FilterName.category_tag)
add(FacetName.co2_emission_values, FilterName.co2_emission_values)
add(FacetName.colour, FilterName.colour)
add(FacetName.distance, FilterName.distance)
add(FacetName.doors_values, FilterName.doors_values)
add(FacetName.driver_position, FilterName.driver_position)
add(FacetName.drivetrain, FilterName.drivetrain)
add(FacetName.drivetrain, FilterName.drivetrain)
add(FacetName.emission_class, FilterName.emission_class)
add(FacetName.end_layout, FilterName.end_layout)
add(FacetName.engine_power, FilterName.min_engine_power, FilterName.max_engine_power)
add(FacetName.engine_size, FilterName.min_engine_size, FilterName.max_engine_size)
add(FacetName.engine_size_cc, FilterName.min_engine_size_cc, FilterName.max_engine_size_cc)
add(FacetName.exterior_length, FilterName.min_exterior_length, FilterName.max_exterior_length)
add(FacetName.finance, FilterName.term, FilterName.deposit, FilterName.yearly_mileage)
add(FacetName.frame_size_cm, FilterName.min_frame_size_cm, FilterName.max_frame_size_cm)
add(FacetName.fuel_consumption_values, FilterName.fuel_consumption_values)
add(FacetName.fuel_type, FilterName.fuel_type)
add(FacetName.gross_trailer_weight, FilterName.min_gross_trailer_weight, FilterName.max_gross_trailer_weight)
add(FacetName.gross_vehicle_weight, FilterName.min_gross_vehicle_weight, FilterName.max_gross_vehicle_weight)
add(FacetName.hours_used, FilterName.min_hours_used, FilterName.max_hours_used)
add(FacetName.insurance_group, FilterName.insurance_group)
add(FacetName.insurance_group, FilterName.insurance_group)
add(FacetName.is_manufacturer_approved, FilterName.is_manufacturer_approved)
add(FacetName.is_writeoff, FilterName.is_writeoff)
add(FacetName.keywords, FilterName.keywords)
add(FacetName.lat_long, FilterName.lat_long)
add(FacetName.lease_in_stock, FilterName.lease_in_stock)
add(FacetName.lease_monthly_price, FilterName.min_lease_monthly_price, FilterName.max_lease_monthly_price)
add(
    FacetName.lease_monthly_price_ex_vat,
    FilterName.min_lease_monthly_price_ex_vat,
    FilterName.max_lease_monthly_price_ex_vat
)
add(FacetName.lease_product_type, FilterName.lease_product_type)
add(FacetName.leasing, FilterName.term, FilterName.deposit, FilterName.yearly_mileage)
add(FacetName.location, FilterName.location)
add(FacetName.make, FilterName.make)
add(FacetName.mileage, FilterName.min_mileage, FilterName.max_mileage)
add(FacetName.mileage_km, FilterName.min_mileage_km, FilterName.max_mileage_km)
add(FacetName.model, FilterName.model)
add(FacetName.monthly_price, FilterName.min_monthly_price, FilterName.max_monthly_price)
add(FacetName.mtplm, FilterName.min_mtplm, FilterName.max_mtplm)
add(FacetName.ni_only, FilterName.ni_only)
add(FacetName.ni_only, FilterName.ni_only)
add(FacetName.part_exchange_available, FilterName.part_exchange_available)
add(FacetName.poa, FilterName.poa)
add(FacetName.postcode, FilterName.postcode)
add(FacetName.price, FilterName.min_price, FilterName.max_price)
add(FacetName.price_search_type, FilterName.price_search_type)
add(FacetName.seats, FilterName.min_seats, FilterName.max_seats)
add(FacetName.seats_values, FilterName.seats_values)
add(FacetName.seller_type, FilterName.seller_type)
add(FacetName.style, FilterName.style)
add(FacetName.sub_style, FilterName.sub_style)
add(FacetName.trailer_axle_number, FilterName.trailer_axle_number)
add(FacetName.transmission, FilterName.transmission)
add(FacetName.ulez_compliant, FilterName.ulez_compliant)
add(FacetName.vat_status, FilterName.vat_status)
add(FacetName.wheelbase, FilterName.wheelbase)
add(FacetName.with_digital_retailing, FilterName.with_digital_retailing)
add(FacetName.with_manufacturer_rrp_saving, FilterName.with_manufacturer_rrp_saving)
add(FacetName.year_manufactured, FilterName.min_year_manufactured, FilterName.max_year_manufactured)

const getFacetByFilter = (filterName: FilterName) => filterFacetMap.get(filterName)?.facet as unknown as FacetName
const getFacetConfig = (facetName: FacetName) => facetFilterMap.get(facetName) as unknown as FacetConfig

const isToggleFacet = (facetName: FacetName) => {
    return facetName === FacetName.poa || facetName === FacetName.location
}

export { getFacetByFilter, getFacetConfig, isToggleFacet }
